export const styles = {
  backgroundColorLoader: (color) => {
    return { backgroundColor: color };
  },
};
